<template>
  <div
    v-if="show && browser === 'IE'"
    class="fixed inset-0 flex-c bg-black opacity-90 z-400"
    role="dialog"
    @click="show = false"
  >
    <div class="flex-c h-48 w-128 p-4 bg-white text-center">
      <div>
        <span class="block">
          Hi it appears you are using Internet Explorer.
          <br>
          In order to get the best experience from this website we highly recommend upgrading to a modern browser such as
          <a
            href="https://www.google.co.uk/chrome/"
            target="_blank"
            class="text-primary underline"
          >
            Google Chrome
          </a>
          or
          <a
            href="https://www.mozilla.org/en-GB/firefox/new/"
            target="_blank"
            class="text-primary underline"
          >
            Firefox
          </a>.
        </span>
        <button
          class="button py-2 px-6 mt-3 btn-hover"
          @click="show = false"
        >
          Dismiss
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'IePrompt',

  data: () => ({
    show: true
  }),

  computed: {
    ...mapState([ 'browser' ])
  }
}
</script>
